window.onload = function () {
  $('#collapseSidebar').on('click', function () {
    $('#sidebar').toggleClass('hidden');
    $('#sidebar').toggleClass('show');
  });

  $('.switch-view').on('click', function () {
    var target = $(this).data('target');
    var source = $(this).data('source');

    $(source).fadeToggle(250, function () {
      $(target).fadeToggle(250);
    });
  });
  /**
   * Prevent form from submitting twice.
   */
  $('form').on('submit', function (e) {
    var $form = $(this);

    if ($form.data('submitted') === true) {
      e.preventDefault();
    } else {
      $form.data('submitted', true);
    }
  });
  /**
   * CTRL + ENTER or COMMAND + ENTER submitting.
   */
  $('textarea').on('keydown', function (e) {
    if (e.ctrlKey && e.keyCode === 13) {
      e.target.form.submit();
    } else if (e.metaKey && e.keyCode === 13) {
      e.target.form.submit();
    }
  });
  /**
   * Toggle form input and view.
   */
  $(document).on('click', '.edit-button', function () {
    $(this).closest('form').find('.input-view').toggle();
    $(this).closest('form').find('.text-view').toggle();
  });
  /**
   * Toggle on off input groups.
   */
  $(document).on('change', '.toggle-group-input', function () {
    let target = $(this).data('target');
    let group = $(this).data('group');

    // Hide and disable.
    $(group + ' input').prop('disabled', true);
    $(group + ' select').prop('disabled', true);
    $(group).hide();

    // Show and enable.
    $(target + ' input').prop('disabled', false);
    $(target + ' select').prop('disabled', false);
    $(target).show();
  });
  /**
   * Toggle on off select groups.
   */
  $(document).on('change', '.toggle-group-select', function () {
    let option = $(this).find('option:selected');
    let target = $(option).data('target');
    let group = $(option).data('group');

    // Hide and disable.
    $(group + ' input').prop('disabled', true);
    $(group + ' select').prop('disabled', true);
    $(group).hide();

    // Show and enable.
    $(target + ' input').prop('disabled', false);
    $(target + ' select').prop('disabled', false);
    $(target).show();
  });
  /**
   * Simple toggle view.
   */
  $(document).on('click', '.simple-toggle', function () {
    var target = $(this).data('show');
    // Only do something if the target has
    // the CSS style: display:none; set.
    if (target && $('#' + target).is(':hidden')) {
      if ($('.simple-toggle-box').is(':visible')) {
        $('.simple-toggle-box').slideUp(250, function () {
          $('#' + target).slideDown(250);
        });
      } else {
        $('#' + target).slideDown(250);
      }
    }
    if (!target) {
      $('.simple-toggle-box').slideUp(250);
    }
  });
  /**
   * Delete button inside modals.
   */
  $('body').on('click', '.delete', function () {
    var modal = $(this).attr('data-modal');
    var target = $(this).attr('data-delete');
    // Close modal.
    $(modal).modal('hide');
    // Delete element.
    $(target).remove();
    // Delete modal.
    $(modal).on('hidden', function () {
      $(this).remove();
    });
  });
  /**
   * Copy button.
   */
  $('body').on('click', '.copy-button', function () {
    let target = $(this).data('target');
    let copy = $(target).children('.form-group').first().clone();
    copy.show();
    copy.find('input, select').prop('disabled', false);
    $(target).append(copy);
  });
  /**
   * Delete button.
   */
  $('body').on('click', '.btn-delete', function () {
    let target = $(this).closest('.form-group');
    target.remove();
  });
  /**
   * Add node copy to DOM.
   */
  $('body').on('click', '#add-node-button', function () {
    // Get variables.
    var node = $('#node-list option:selected').val();
    var count = parseInt($('input[name=next_content_node_key]').val());
    // Copy node.
    var copy = $('#node_type_' + node).children().clone(true, true);
    // Get name attribute.
    var name = copy.find(':input').attr('name');
    var button = copy.find('[data-target*="modalDeleteElementDialog-"]').data('target');
    var modalId = copy.find('[id*="modalDeleteElementDialog-"]').attr('id');
    var modalTarget = copy.find('[data-modal*="modalDeleteElementDialog-"]').data('modal');
    var modalDelete = copy.find('[data-delete*="node-"]').data('delete');
    // Update clonable element with new name.
    copy.removeAttr('id');
    copy.find('.input-view').removeAttr('style');
    copy.find('.list-group-item').attr('id', 'node-' + name + '-' + count);
    copy.find(':input').attr('name', name + '[' + count + ']');
    copy.find('[id*="modalDeleteElementDialog-"]').attr('id', modalId + count);
    copy.find('[data-target*="modalDeleteElementDialog-"]').attr('data-target', button + count);
    copy.find('[data-modal*="modalDeleteElementDialog-"]').attr('data-modal', modalTarget + count);
    copy.find('[data-delete*="node-"]').attr('data-delete', modalDelete + count);
    // Append to form.
    $('#content-form').append(copy);
    // Update count.
    $('input[name=next_content_node_key]').val(count + 1);
  });

  /**
   * Axios check buttons.
   */
  $('body').on('click', '.btn-axios-check', function (event) {
    // Post data.
    let action = $(this).data('action');
    let target = $(this).data('target');

    excludeUrl(action);

    axios.post(action, {'_method': 'PUT'})
      .then(function () {
        //
      });
    // Remove row.
    $('#' + target).fadeOut(250, function () {
      $(this).remove();
    });

  });
}

/**
 * Normal table sorting.
 *
 * @param sortName
 * @param sortOrder
 * @param data
 * @return void
 */
normalTableSort = function (sortName, sortOrder, data) {
  let order = sortOrder === 'desc' ? -1 : 1;
  data.sort(function (a, b) {
    let aa = +((a[sortName] + '').replace(/\D/g, ''));
    let bb = +((b[sortName] + '').replace(/\D/g, ''));
    if (aa < bb) {
      return order * -1;
    }
    if (aa > bb) {
      return order;
    }
    return 0;
  });
}

/**
 * Show toast messages.
 *
 * @return void
 */
showToasts = function () {
  $('.toast').toast('show');
}

/**
 * Simple function to toggle between
 * regular UI and fullscreen UI.
 *
 * @return void
 */
toggleFullscreen = function () {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen().then(r => {
      // We don't need to do anything
      // with the returned Promise.
    });
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen().then(r => {
        // We don't need to do anything
        // with the returned Promise.
      });
    }
  }
}

/**
 * Resize iframes.
 *
 * @param iframe
 * @return void
 */
resizeIframe = function (iframe) {
  iframe.style.height = iframe.contentWindow.document.documentElement.scrollHeight + 'px';
}

/**
 * Generate random password on click.
 *
 * @param context
 * @param length
 * @return string
 */
generatePassword = function (context, length = 24) {
  let rand;
  let pass = '';
  let arr = '0123456789ABCDEFGHJKLMNOPQRSTUVWXTZabcdefghikmnopqrstuvwxyz%$#@&*()[]{};;<>?';

  for (let i = 0; i < length; i++) {
    rand = Math.floor(Math.random() * arr.length);
    pass += arr.substring(rand, rand + 1);
  }
  document.getElementById(context).value = pass;
}
